export default __webpack_public_path__ + "static/media/telefone.5f9a0709.svg";